import { create } from "zustand"

type AuthState = {
  username: string | null
  password: string | null,
  userId: string | null,
  setUsername: (username: string) => void,
  setPassword: (password: string) => void,
  setCredentials: (username: string, password: string, userId: string) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  username: null,
  password: null,
  userId: null,
  setUsername: (username) => set({ username: username }),
  setPassword: (password) => set({ password: password }),
  setCredentials: (username, password, userId) =>
    set({ username, password, userId }),
  clear: () =>
    set({ username: null, password: null, userId: null }),
}))